import { useNavigate } from 'react-router-dom';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/shared/components/ui/alert-dialog';
import { useUIStore } from '@/shared/stores/ui.store';
import { useUserRole } from '@/shared/hooks/useUserRole';
import { CONSENT_STRINGS } from '@/shared/constants';

/**
 * App-wide modal shown when a gated action is rejected with a consent-required 403
 * (the axios interceptor opens it). Mounted once at the app root. Offers Cancel or a
 * shortcut to the profile page where the user can restore consent.
 */
export function ConsentRequiredModal() {
  const navigate = useNavigate();
  const activeModal = useUIStore((s) => s.activeModal);
  const closeModal = useUIStore((s) => s.closeModal);
  // The modal is mounted app-wide, but consent (and the profile restore page)
  // is a user-portal concept. Only offer the profile shortcut to a regular user,
  // so an admin/reviewer is never routed to /user/profile (a role-gated route).
  const { isUser } = useUserRole();

  const open = activeModal === 'consentRequired';

  return (
    <AlertDialog open={open} onOpenChange={(next) => !next && closeModal()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{CONSENT_STRINGS.MODAL_TITLE}</AlertDialogTitle>
          <AlertDialogDescription>
            {CONSENT_STRINGS.MODAL_BODY}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={closeModal}>
            {CONSENT_STRINGS.MODAL_CANCEL}
          </AlertDialogCancel>
          {isUser && (
            <AlertDialogAction
              onClick={() => {
                closeModal();
                navigate('/user/profile');
              }}
            >
              {CONSENT_STRINGS.MODAL_GO_TO_PROFILE}
            </AlertDialogAction>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
